import { GET_LATEST_REPORT } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_LATEST_REPORT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_LATEST_REPORT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_LATEST_REPORT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
